import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'plus', 'minus']

  connect () {
    this.inputTarget.addEventListener('input', this.#refreshButtons)
    this.#refreshButtons()
  }

  disconnect () {
    this.inputTarget.removeEventListener('input', this.#refreshButtons)
  }

  // Helpers
  get min () {
    const value = parseInt(this.inputTarget.getAttribute('min'))
    return Number.isNaN(value) ? -Infinity : value
  }

  get max () {
    const value = parseInt(this.inputTarget.getAttribute('max'))
    return Number.isNaN(value) ? Infinity : value
  }

  get step () {
    const attr = this.inputTarget.getAttribute('step')
    const value = parseInt(attr)
    return Number.isNaN(value) || attr === 'any' ? 1 : value
  }

  currentValue () {
    const value = parseFloat(this.inputTarget.value)
    if (Number.isNaN(value)) {
      return Number.isFinite(this.min) ? this.min : 0
    }
    return value
  }

  setValue (value) {
    const bounded = Math.max(this.min, Math.min(this.max, value))
    const rounded = this.#roundToInputScale(bounded)
    if (String(rounded) === this.inputTarget.value) return

    this.inputTarget.value = rounded
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.element.dispatchEvent(new CustomEvent('number-input:change', { detail: { value: rounded } }))
  }

  increment () {
    this.setValue(this.currentValue() + this.step)
  }

  decrement () {
    this.setValue(this.currentValue() - this.step)
  }

  #roundToInputScale (value) {
    const fraction = this.inputTarget.value.split('.')[1]
    const digits = fraction ? fraction.length : 0
    const scale = 10 ** digits
    return Math.round(value * scale) / scale
  }

  #refreshButtons = () => {
    const value = this.currentValue()
    if (this.hasPlusTarget) this.plusTarget.setAttribute('aria-disabled', value >= this.max)
    if (this.hasMinusTarget) this.minusTarget.setAttribute('aria-disabled', value <= this.min)
  }
}
